/* unplugin-vue-components disabled */import script from "./Param.vue?vue&type=script&setup=true&lang=tsx"
export * from "./Param.vue?vue&type=script&setup=true&lang=tsx"

const __exports__ = script;

export default __exports__